/** Body of the live fragment upload: `multipart/form-data` with a single file field named `chunk`. */
class SendLiveFragment {
	constructor(
		public readonly segment: number,
		public readonly index: number,
		public readonly chunk: Blob,
	) {
		Object.freeze(this);
	}

	toFormData(): FormData {
		const formData = new FormData();
		formData.append('chunk', this.chunk);

		return formData;
	}
}

export default SendLiveFragment;
